<template>
    <div :style="styles.container">
      <h1 :style="styles.title">Authentication Form</h1>
      <div :style="styles.form">
        <input
          type="email"
          v-model="email"
          placeholder="Email Address"
          :style="styles.input"
        />
        <div :style="styles.inputContainer">
          <input
            :type="isPasswordVisible ? 'text' : 'password'"
            v-model="password"
            placeholder="Password"
            :style="styles.input"
          />
          <div
            :style="styles.eyeIcon"
            @click="togglePasswordVisibility"
          >
            <span v-if="isPasswordVisible">👁️</span>
            <span v-else>🙈</span>
          </div>
        </div>
        <button
          @click="handleSubmit"
          :style="styles.submitButton"
          @mouseover="onMouseEnter"
          @mouseleave="onMouseLeave"
        >
          Submit
        </button>
        <p v-if="error" :style="styles.error">{{ error }}</p>
      </div>
    </div>
  </template>
  
  <script>
  import { ref } from "vue";
  import { useRouter } from "vue-router";
  import { signIn, signUp, getUserCount } from "@/firebase/firebase"; 
  
  export default {
    name: "AuthForm",
    setup() {
      const email = ref("");
      const password = ref("");
      const error = ref("");
      const isPasswordVisible = ref(false);
      const router = useRouter();
  
      const togglePasswordVisibility = () => {
        isPasswordVisible.value = !isPasswordVisible.value;
      };
  
      const handleSubmit = async () => {
        try {
          const userCount = await getUserCount();
  
          if (userCount >= 12) {
            error.value = "Please contact the admin if you want to create a new account.";
            return;
          }
  
          if (!email.value.endsWith("@inteqt.es")) {
            error.value = "Please enter a valid email address";
            return;
          }
  
          try {
            await signIn(email.value, password.value);
            router.push("/blogs");
          } catch (signInError) {
            console.log("Sign-in failed, trying to sign up...");
  
            try {
              await signUp(email.value, password.value);
              router.push("/blogs");
            } catch (signUpError) {
              error.value = signUpError.message;
            }
          }
        } catch (err) {
          error.value = err.message;
        }
      };
  
      const styles = {
        container: {
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
          textAlign: "center",
          backgroundColor: "#f4f4f4",
          padding: "20px",
        },
        title: {
          fontSize: "2rem",
          marginBottom: "20px",
          color: "black",
        },
        form: {
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          width: "100%",
          maxWidth: "400px",
          backgroundColor: "white",
          padding: "30px",
          borderRadius: "10px",
          boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
        },
        input: {
          padding: "12px",
          fontSize: "1rem",
          marginBottom: "15px",
          width: "100%",
          maxWidth: "300px",
          borderRadius: "5px",
          border: "1px solid #ddd",
          boxSizing: "border-box",
          position: "relative",
        },
        submitButton: {
          padding: "12px 20px",
          fontSize: "1rem",
          cursor: "pointer",
          backgroundColor: "#007bff",
          color: "white",
          border: "none",
          borderRadius: "5px",
          transition: "background-color 0.3s ease",
          width: "100%",
          maxWidth: "300px",
        },
        submitButtonHover: {
          backgroundColor: "#0056b3",
        },
        error: {
          color: "red",
          marginTop: "15px",
        },
        eyeIcon: {
          position: "absolute",
          right: "15px",
          top: "50%",
          transform: "translateY(-80%)",
          cursor: "pointer",
          color: "#007bff",
        },
        inputContainer: {
          position: "relative",
          width: "100%",
          maxWidth: "300px",
        },
      };
  
      return {
        email,
        password,
        error,
        isPasswordVisible,
        togglePasswordVisibility,
        handleSubmit,
        styles,
      };
    },
  };
  </script>
  
  <style scoped>
 
  </style>
  